var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSynchronize({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.116 12.856a.781.781 0 0 0 .383 1.515 6.551 6.551 0 0 0 4.785-5.136.157.157 0 0 1 .14-.125l1.057-.095a.312.312 0 0 0 .203-.52l-2-2.22a.33.33 0 0 0-.26-.101.313.313 0 0 0-.238.147l-1.57 2.54a.313.313 0 0 0 .266.477h.028l.524-.047a.156.156 0 0 1 .163.202 4.95 4.95 0 0 1-3.481 3.363zM5.144 1.721a.156.156 0 0 1-.175-.07L4.424.75a.312.312 0 0 0-.557.045L2.75 3.567a.313.313 0 0 0 .259.427l2.97.296h.032a.313.313 0 0 0 .267-.474l-.286-.473a.156.156 0 0 1 .11-.235 4.941 4.941 0 0 1 4.567 1.673.781.781 0 1 0 1.193-1.01 6.517 6.517 0 0 0-6.718-2.05zM1.599 5.466a.778.778 0 0 0-.997.477 6.558 6.558 0 0 0 1.614 6.842c.05.049.062.126.028.188l-.5.918a.313.313 0 0 0 .32.459l2.954-.432a.312.312 0 0 0 .239-.438l-1.244-2.718a.312.312 0 0 0-.559-.02l-.265.489a.156.156 0 0 1-.258.024 4.979 4.979 0 0 1-.856-4.791.781.781 0 0 0-.476-.998z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSynchronize);
export default __webpack_public_path__ + "static/media/synchronize.ec7c9936720019dc0ca5c7630ce5c797.svg";
export { ForwardRef as ReactComponent };